<template>
    <div class="container">
        <search-result-header
          :keyword="params.keyword"
          :show-tabs="false"
          @search="searchCurrentPage"
        />
        <goodslist-body :key="$route.fullPath"></goodslist-body>
    </div>
</template>

<script>
import GoodslistBody from './GoodslistBody'
import SearchResultHeader from '../common/SearchResultHeader'
export default {
  name: 'HomeGoodslist',
  components: {
    GoodslistBody,
    SearchResultHeader
  },
  data () {
    return {
      params: {
        keyword: this.$route.query.keywords ? this.$route.query.keywords : ''
      }

    }
  },
  watch: {
    '$route.query.keywords' (value) {
      this.params.keyword = value || ''
    }
  },
  methods: {
    searchCurrentPage (keyword) {
      if ((this.$route.query.keywords || '') === keyword) return
      const query = Object.assign({}, this.$route.query)
      if (keyword) query.keywords = keyword
      else delete query.keywords
      this.$router.replace({ name: 'HomeGoodslist', query: query })
    }
  }
}
</script>

<style scoped>

</style>
